import { render, staticRenderFns } from "./DlgEventNew.vue?vue&type=template&id=9ec86200&scoped=true"
import script from "./DlgEventNew.vue?vue&type=script&lang=ts"
export * from "./DlgEventNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec86200",
  null
  
)

export default component.exports